
  document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
      const widget = document.querySelector("#cm-ymm .cm_collapsible-elem");
      const arrow = document.querySelector("#cm-ymm .cm_icon-angle");

      if (widget) {
        widget.style.height = "auto";   
        widget.style.overflow = "visible"; 
      }

      if (arrow) {
        arrow.classList.remove("down");
        arrow.classList.add("up");        
      }
    }, 500); 
  });

